// Shared TTL-liveness check for every `expiresAt`-bearing entry in the assistant-surface-context
// protocol (committed-state accumulator entries, ...). Centralised so every caller makes the same
// clock-skew/format assumptions -- two separate inline copies of `Date.parse(x) > Date.now()` is
// exactly the kind of duplication that drifts silently if either one's edge-case handling ever
// needs to change.
export function isLive(expiresAt: string): boolean {
  return Date.parse(expiresAt) > Date.now()
}

// This retains search/selection intent, not supplier availability. Quotes and
// booking actions still use their own supplier expiry and canonical cart state.
export const COMMITTED_STATE_TTL_MS = 24 * 60 * 60 * 1000

export function buildCommittedStateExpiresAt(): string {
  return new Date(Date.now() + COMMITTED_STATE_TTL_MS).toISOString()
}
